function StatCard({
  title,
  value,
  description,
  icon: Icon,
  trend,
  trendDirection = 'up',
}) {
  const isDown = trendDirection === 'down';

  const canRenderIcon =
    Icon && (typeof Icon === 'function' || typeof Icon === 'object');

  return (
    <article className="dashboard-stat-card">
      <div className="dashboard-stat-card__header">
        <span className="dashboard-stat-card__icon">
          {canRenderIcon ? (
            <Icon size={22} strokeWidth={2.4} />
          ) : (
            <span className="dashboard-stat-card__fallback-icon">?</span>
          )}
        </span>

        {trend && (
          <span
            className={`dashboard-stat-card__trend ${
              isDown
                ? 'dashboard-stat-card__trend--down'
                : 'dashboard-stat-card__trend--up'
            }`}
          >
            <span className="dashboard-stat-card__trend-arrow">
              {isDown ? '↘' : '↗'}
            </span>
            {trend}
          </span>
        )}
      </div>

      <div className="dashboard-stat-card__body">
        <p>{title}</p>
        <strong>{value}</strong>
        <span>{description}</span>
      </div>
    </article>
  );
}

export default StatCard;